/* eslint-disable react/button-has-type */
import { lazy, Suspense } from "react";
import classNames from "classnames";

// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

// Icons
const LazyAround = lazy(() => import("assets/icons/glory/around.svg?react"));

type ButtonGirlProps = {
  disabled: boolean;
  attempts: number;
  onClick: () => void;
};

const ButtonGirl = (props: ButtonGirlProps) => {
  const { disabled, attempts, onClick } = props;

  const t = useTranslate();

  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  const btnClass = classNames("ButtonGirl", {
    banger: VITE_APP_PROJECT_NAME === "banger",
  });

  return (
    <button
      className={btnClass}
      // eslint-disable-next-line react/jsx-handler-names
      onClick={onClick}
      disabled={disabled || attempts === 0}
    >
      <div className="ButtonGirl-center">
        <Suspense fallback="">
          <LazyAround className="ButtonGirl-center__image" />
        </Suspense>
        <span className="ButtonGirl-center__text">{t("wheel.spin")}</span>
      </div>
    </button>
  );
};

export default ButtonGirl;
